import CrudRepository from './CrudRepository'
export default class RoamingCitiesRepository extends CrudRepository {
  constructor () {
    super('/customerCare/api/roamingCountry/web')
  }
}
